import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const BuyResult = ({ result }) => {
  if (!result) return null;
  return (
    <AnimatePresence>
      <motion.div
        initial={{ opacity: 0, y: -10 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0 }}
        className={`rounded-lg p-3 mb-3 border ${result.success ? 'bg-[#C9A84C]/10 border-[#C9A84C]/30' : 'bg-[#8B1A1A]/10 border-[#8B1A1A]/30'}`}
        data-testid="store-buy-result"
      >
        <p className="font-['Cormorant_Garamond'] italic text-sm" style={{ color: result.success ? '#C9A84C' : '#8B1A1A' }}>
          "{result.matt_line}"
        </p>
        {result.applied && result.applied.length > 0 && (
          <div className="flex flex-wrap gap-1 mt-1">
            {result.applied.map((a, i) => (
              <span key={i} className="font-['Outfit'] text-[#E8E0D0]/50 text-[9px] bg-[#E8E0D0]/5 px-1.5 py-0.5 rounded">{a}</span>
            ))}
          </div>
        )}
      </motion.div>
    </AnimatePresence>
  );
};

export default BuyResult;
